import type { AtAGlanceOutput } from './atAGlanceTypes.ts';

/**
 * The per-link one-liners of a cc-smarts response, keyed by ARI. A row looks its
 * own summary up by `link.ari` — the same identifier `buildAtAGlanceInput` sent
 * for that link, so anything the model answered for is matchable.
 */
export type AtAGlanceSummaries = ReadonlyMap<string, string>;

export const EMPTY_AT_A_GLANCE_SUMMARIES: AtAGlanceSummaries = new Map();

/**
 * Indexes the response's summaries by ARI. The first summary wins if the model
 * repeats an ARI, and the title it echoed back is dropped: rows already have the
 * resolver's title, which is the one the user sees everywhere else.
 */
export const buildAtAGlanceSummaries = (output: AtAGlanceOutput | null): AtAGlanceSummaries => {
	if (output?.status !== 'GENERATED' || !output.summaries.length) {
		return EMPTY_AT_A_GLANCE_SUMMARIES;
	}

	const byAri = new Map<string, string>();
	for (const { ari, oneLiner } of output.summaries) {
		if (!byAri.has(ari)) {
			byAri.set(ari, oneLiner);
		}
	}
	return byAri;
};
